$( document ).ready(function() {
    $('.announcement-bar__icon--search').click(function(){
        $('summary.header__icon--search').trigger('click');
    });

    $('.menu-drawer__close--button').click(function(){
      $('.header__icon--summary').trigger('click');
    })

    var $headerSticky = $('.section-header');
    var $announcementBarHeight = $('#shopify-section-announcement-bar').height();
    $headerSticky.css('top', $announcementBarHeight);

    $(window).resize(function(){
      var $announcementBarHeight = $('#shopify-section-announcement-bar').height();
    $headerSticky.css('top', $announcementBarHeight);
    })

    $('.announcement-bar__icon--search').click(function(){
      if($('.shopify-section-header-hidden').length){
        $('#shopify-section-header').removeClass('shopify-section-header-hidden');

        if($('.shopify-section--tabs').length){
          var $announcementHeight = $('#shopify-section-announcement-bar').height();
          var $stickyHeaderHeight = $('#sticky-header-wrapper').height();
          $tabs = $announcementHeight + $stickyHeaderHeight + 'px';
          $('.shopify-section--tabs').css('top', $tabs);
        }
      }
    })
});